module.exports = "/images/logo-onegen01.jpg?bf84fc35c1c4ca1b762a62fb04b3ca81";